import { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';

import PropTypes from 'prop-types';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

import MDBox from 'components/MDBox';

import Breadcrumbs from 'components/Breadcrumbs';
import { navbar, navbarContainer, navbarRow } from 'components/Navbars/PortalNavbar/styles'; // Material Dashboard 2 React
import { setTransparentNavbar, useMaterialUIController } from 'context';

function PortalNavbar({ view }) {
  const [previousNavbarTransparent, setPreviousNavbarTransparent] = useState();

  const { controller, dispatch, pageTitle } = useMaterialUIController();
  const { transparentNavbar, fixedNavbar, darkMode } = controller;

  const routePath = useLocation().pathname.split('/').slice(1);

  useEffect(() => {
    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      const transparentNavbar = (fixedNavbar && window.scrollY === 0) || !fixedNavbar;
      if (transparentNavbar !== previousNavbarTransparent) {
        setTransparentNavbar(dispatch, transparentNavbar);
      }
      setPreviousNavbarTransparent(transparentNavbar);
    }

    /**
     The event listener that's calling the handleTransparentNavbar function when
     scrolling the window.
     */
    window.addEventListener('scroll', handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener('scroll', handleTransparentNavbar);
  }, [dispatch, fixedNavbar, previousNavbarTransparent]);

  return (
    <AppBar
      position="static"
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, darkMode })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)} id="toolbar">
        <MDBox
          color="inherit"
          mb={{ xs: 1, md: 0 }}
          sx={(theme) => navbarRow(theme, { isMini: false })}
        >
          <Breadcrumbs
            routePath={routePath}
            view={view}
            pageTitle={pageTitle}
            backIcon="arrow_back"
          />
        </MDBox>
      </Toolbar>
    </AppBar>
  );
}

PortalNavbar.defaultProps = {};

PortalNavbar.propTypes = {
  view: PropTypes.string
};

export default PortalNavbar;
